export { $contentOverlayed, setContentOverlayedEvent } from './content-overlayed';
